var cov_ek9segysr = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Meta.tsx",
      hash = "3551edec0b6f7eb4c5c78420b14db15f22aac448",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Meta.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 18
        },
        end: {
          line: 7,
          column: 87
        }
      },
      "1": {
        start: {
          line: 7,
          column: 50
        },
        end: {
          line: 7,
          column: 87
        }
      },
      "2": {
        start: {
          line: 7,
          column: 74
        },
        end: {
          line: 7,
          column: 85
        }
      },
      "3": {
        start: {
          line: 19,
          column: 23
        },
        end: {
          line: 19,
          column: 33
        }
      },
      "4": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 28
        }
      },
      "5": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 20,
          column: 28
        }
      },
      "6": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "7": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 64
        }
      },
      "8": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "9": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 66
        }
      },
      "10": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 32,
          column: 7
        }
      },
      "11": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 32,
          column: 7
        }
      },
      "12": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 15
        }
      },
      "13": {
        start: {
          line: 38,
          column: 28
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "14": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 27
        }
      },
      "15": {
        start: {
          line: 39,
          column: 16
        },
        end: {
          line: 39,
          column: 27
        }
      },
      "16": {
        start: {
          line: 40,
          column: 17
        },
        end: {
          line: 40,
          column: 22
        }
      },
      "17": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 78
        }
      },
      "18": {
        start: {
          line: 45,
          column: 28
        },
        end: {
          line: 45,
          column: 38
        }
      },
      "19": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 26
        }
      },
      "20": {
        start: {
          line: 46,
          column: 15
        },
        end: {
          line: 46,
          column: 26
        }
      },
      "21": {
        start: {
          line: 47,
          column: 17
        },
        end: {
          line: 47,
          column: 23
        }
      },
      "22": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 76
        }
      },
      "23": {
        start: {
          line: 52,
          column: 24
        },
        end: {
          line: 52,
          column: 34
        }
      },
      "24": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 29
        }
      },
      "25": {
        start: {
          line: 53,
          column: 18
        },
        end: {
          line: 53,
          column: 29
        }
      },
      "26": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 87
        }
      },
      "27": {
        start: {
          line: 54,
          column: 25
        },
        end: {
          line: 54,
          column: 87
        }
      },
      "28": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 64
        }
      },
      "29": {
        start: {
          line: 59,
          column: 48
        },
        end: {
          line: 59,
          column: 58
        }
      },
      "30": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "31": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 98
        }
      },
      "32": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "33": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 73,
          column: 7
        }
      },
      "34": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 18
          },
          end: {
            line: 7,
            column: 19
          }
        },
        loc: {
          start: {
            line: 7,
            column: 50
          },
          end: {
            line: 7,
            column: 87
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 69
          },
          end: {
            line: 7,
            column: 70
          }
        },
        loc: {
          start: {
            line: 7,
            column: 74
          },
          end: {
            line: 7,
            column: 85
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 17
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 18
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 15
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 44
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 18
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 51
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        loc: {
          start: {
            line: 58,
            column: 11
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 28
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 28
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 32,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 32,
            column: 7
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 32,
            column: 7
          }
        }],
        line: 27
      },
      "4": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 27
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 27
          }
        }],
        line: 39
      },
      "5": {
        loc: {
          start: {
            line: 41,
            column: 46
          },
          end: {
            line: 41,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 46
          },
          end: {
            line: 41,
            column: 50
          }
        }, {
          start: {
            line: 41,
            column: 54
          },
          end: {
            line: 41,
            column: 62
          }
        }],
        line: 41
      },
      "6": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 26
          }
        }, {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 26
          }
        }],
        line: 46
      },
      "7": {
        loc: {
          start: {
            line: 48,
            column: 45
          },
          end: {
            line: 48,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 45
          },
          end: {
            line: 48,
            column: 49
          }
        }, {
          start: {
            line: 48,
            column: 53
          },
          end: {
            line: 48,
            column: 61
          }
        }],
        line: 48
      },
      "8": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 29
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 29
          }
        }],
        line: 53
      },
      "9": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 87
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 87
          }
        }],
        line: 54
      },
      "10": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }],
        line: 62
      },
      "11": {
        loc: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 16
          }
        }, {
          start: {
            line: 62,
            column: 20
          },
          end: {
            line: 62,
            column: 26
          }
        }, {
          start: {
            line: 62,
            column: 30
          },
          end: {
            line: 62,
            column: 35
          }
        }],
        line: 62
      },
      "12": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }],
        line: 67
      },
      "13": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 14
          }
        }, {
          start: {
            line: 67,
            column: 18
          },
          end: {
            line: 67,
            column: 23
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/Meta.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement } from 'react';
import classnames from 'classnames';
import { isFunc, isString } from '../utils/is';
import { listClass } from './styles';
import Image from '../Image';
cov_ek9segysr.s[0]++;

var metaClass = function metaClass() {
  cov_ek9segysr.f[0]++;
  cov_ek9segysr.s[1]++;

  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }

  return listClass.apply(void 0, _toConsumableArray(a.map(function (v) {
    cov_ek9segysr.f[1]++;
    cov_ek9segysr.s[2]++;
    return "meta-".concat(v);
  })));
};

var Meta =
/*#__PURE__*/
function (_Component) {
  _inherits(Meta, _Component);

  var _super = _createSuper2(Meta);

  function Meta() {
    _classCallCheck(this, Meta);

    return _super.apply(this, arguments);
  }

  _createClass(Meta, [{
    key: "renderAvatar",
    value: function renderAvatar() {
      cov_ek9segysr.f[2]++;

      var _ref = (cov_ek9segysr.s[3]++, this.props),
          avatar = _ref.avatar;

      cov_ek9segysr.s[4]++;

      if (!avatar) {
        cov_ek9segysr.b[0][0]++;
        cov_ek9segysr.s[5]++;
        return null;
      } else {
        cov_ek9segysr.b[0][1]++;
      }

      cov_ek9segysr.s[6]++;

      if (
      /*#__PURE__*/
      isValidElement(avatar)) {
        cov_ek9segysr.b[1][0]++;
        cov_ek9segysr.s[7]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: metaClass('avatar'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 22,
              columnNumber: 14
            }
          }, avatar)
        );
      } else {
        cov_ek9segysr.b[1][1]++;
      }

      cov_ek9segysr.s[8]++;

      if (isFunc(avatar)) {
        cov_ek9segysr.b[2][0]++;
        cov_ek9segysr.s[9]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: metaClass('avatar'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 25,
              columnNumber: 14
            }
          }, avatar())
        );
      } else {
        cov_ek9segysr.b[2][1]++;
      }

      cov_ek9segysr.s[10]++;

      if (isString(avatar)) {
        cov_ek9segysr.b[3][0]++;
        cov_ek9segysr.s[11]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: metaClass('avatar'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 29,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Image, {
            lazy: true,
            src: avatar,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 30,
              columnNumber: 11
            }
          }))
        );
      } else {
        cov_ek9segysr.b[3][1]++;
      }

      cov_ek9segysr.s[12]++;
      return null;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      cov_ek9segysr.f[3]++;

      var _ref2 = (cov_ek9segysr.s[13]++, this.props),
          title = _ref2.title,
          desc = _ref2.desc;

      cov_ek9segysr.s[14]++;

      if (!title) {
        cov_ek9segysr.b[4][0]++;
        cov_ek9segysr.s[15]++;
        return null;
      } else {
        cov_ek9segysr.b[4][1]++;
      }

      var flag = (cov_ek9segysr.s[16]++, !desc);
      cov_ek9segysr.s[17]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('title', (cov_ek9segysr.b[5][0]++, flag) && (cov_ek9segysr.b[5][1]++, 'center')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41,
            columnNumber: 12
          }
        }, title)
      );
    }
  }, {
    key: "renderDesc",
    value: function renderDesc() {
      cov_ek9segysr.f[4]++;

      var _ref3 = (cov_ek9segysr.s[18]++, this.props),
          desc = _ref3.desc,
          title = _ref3.title;

      cov_ek9segysr.s[19]++;

      if (!desc) {
        cov_ek9segysr.b[6][0]++;
        cov_ek9segysr.s[20]++;
        return null;
      } else {
        cov_ek9segysr.b[6][1]++;
      }

      var flag = (cov_ek9segysr.s[21]++, !title);
      cov_ek9segysr.s[22]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('desc', (cov_ek9segysr.b[7][0]++, flag) && (cov_ek9segysr.b[7][1]++, 'center')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48,
            columnNumber: 12
          }
        }, desc)
      );
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      cov_ek9segysr.f[5]++;

      var _ref4 = (cov_ek9segysr.s[23]++, this.props),
          content = _ref4.content;

      cov_ek9segysr.s[24]++;

      if (!content) {
        cov_ek9segysr.b[8][0]++;
        cov_ek9segysr.s[25]++;
        return null;
      } else {
        cov_ek9segysr.b[8][1]++;
      }

      cov_ek9segysr.s[26]++;

      if (isFunc(content)) {
        cov_ek9segysr.b[9][0]++;
        cov_ek9segysr.s[27]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: metaClass('content'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 54,
              columnNumber: 33
            }
          }, content())
        );
      } else {
        cov_ek9segysr.b[9][1]++;
      }

      cov_ek9segysr.s[28]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('content'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55,
            columnNumber: 12
          }
        }, content)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_ek9segysr.f[6]++;

      var _ref5 = (cov_ek9segysr.s[29]++, this.props),
          className = _ref5.className,
          content = _ref5.content,
          title = _ref5.title,
          desc = _ref5.desc; // if content && title && desc is all null, just render avatar


      cov_ek9segysr.s[30]++;

      if ((cov_ek9segysr.b[11][0]++, !content) && (cov_ek9segysr.b[11][1]++, !title) && (cov_ek9segysr.b[11][2]++, !desc)) {
        cov_ek9segysr.b[10][0]++;
        cov_ek9segysr.s[31]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classnames(listClass('meta'), className),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 63,
              columnNumber: 14
            }
          }, this.renderAvatar())
        );
      } else {
        cov_ek9segysr.b[10][1]++;
      } // if title && desc is null, render classic layout


      cov_ek9segysr.s[32]++;

      if ((cov_ek9segysr.b[13][0]++, !title) && (cov_ek9segysr.b[13][1]++, !desc)) {
        cov_ek9segysr.b[12][0]++;
        cov_ek9segysr.s[33]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classnames(listClass('meta', 'includes'), className),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69,
              columnNumber: 9
            }
          }, this.renderAvatar(), this.renderContent())
        );
      } else {
        cov_ek9segysr.b[12][1]++;
      } // full layout


      cov_ek9segysr.s[34]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(listClass('meta'), className),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 78,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('container'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79,
            columnNumber: 9
          }
        }, this.renderAvatar(),
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('meta'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81,
            columnNumber: 11
          }
        }, this.renderTitle(), this.renderDesc())), this.renderContent())
      );
    }
  }]);

  return Meta;
}(Component);

export default Meta;